import { jsxs as u, jsx as l } from "react/jsx-runtime";
import { forwardRef as C } from "react";
import c from "@mui/material/FormControl";
import R from "@mui/material/RadioGroup";
import G from "../../FormLabel/FormLabel.js";
const g = {
  root: "radioGroupRoot"
}, F = {
  root: "formControlRoot",
  marginNormal: "formControlMarginNormal",
  marginDense: "formControlMarginDense",
  fullWidth: "formControlFullwidth"
}, h = /* @__PURE__ */ C(({ className: t, children: m, classes: i, disabled: o = !1, error: r = !1, FormControlProps: f = void 0, FormLabelProps: e = void 0, fullWidth: a = !1, label: n = void 0, required: s = !1, ...d }, p) => /* @__PURE__ */ u(c, {
  ...f,
  classes: F,
  className: t,
  disabled: o,
  error: r,
  fullWidth: a,
  required: s,
  children: [
    /* @__PURE__ */ l(G, {
      ...e,
      disabled: o,
      error: r,
      fullWidth: a,
      required: s,
      children: n
    }),
    /* @__PURE__ */ l(R, {
      ...d,
      ref: p,
      classes: {
        ...g,
        ...i
      },
      children: m
    })
  ]
}));
h.displayName = "RadioGroup";
export {
  h as default
};
